var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerFooter font16 flex alignItemsCenter justifyContentCenter"},[_c('span',[_vm._v(_vm._s(_vm.l('bqsy')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }